import { CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { brl } from "@/lib/pricing";

export const SucessoDialog = ({ data, onClose }) => (
  <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="booking-success-dialog" data-lenis-prevent className="rounded-none border-0 bg-[#f4f0e6] p-8 sm:p-10">
      <CheckCircle2 className="h-14 w-14 text-[#7ab51d]" />
      <DialogTitle data-testid="booking-success-message" className="text-3xl font-bold leading-tight tracking-tight text-[#1a382b]">
        Sua reserva foi concluída com Sucesso!
      </DialogTitle>
      <DialogDescription className="text-base text-[#3d4a34]">
        {data?.nome} · {data?.periodo}
        <br />
        Total: <strong className="text-[#1a382b]">{brl(data?.total)}</strong>
        <br />
        Em breve nossa equipe entrará em contato pelo WhatsApp para confirmar os detalhes.
      </DialogDescription>
      <button
        data-testid="booking-success-close-button"
        onClick={onClose}
        className="mt-2 w-full rounded-full bg-[#1a382b] py-4 text-sm font-bold uppercase tracking-[0.16em] text-[#f3efe4] transition-colors hover:bg-[#244b39]"
      >
        Fechar
      </button>
    </DialogContent>
  </Dialog>
);
